require('./bootstrap');

import { createApp } from 'vue';
// import CKEditor from '@ckeditor/ckeditor5-vue';

const Vue = createApp({});

// Vue.use(CKEditor);

// import ExampleComponent from '../components/ExampleComponent.vue';
// Vue.component('example', ExampleComponent);

// Vue.component('example-component', require('./components/ExampleComponent.vue').default);
Vue.component('projects-slider', require('./components/ProjectsSlider.vue').default);
Vue.component('project-overlay', require('./components/Overlay.vue').default);

Vue.component('news-section', require('./components/Sections/NewsSection.vue').default);
Vue.component('news-slider', require('./components/NewsSlider.vue').default);

Vue.component('team-section', require('./components/Sections/TeamSection.vue').default);
Vue.component('perks-slider', require('./components/PerksSlider.vue').default);

Vue.component('careers-section', require('./components/Sections/CareersSection.vue').default);
Vue.component('open-positions', require('./components/OpenPositions.vue').default);

Vue.component('Success', require('./components/Animations/Success.vue').default);
Vue.component('scroll-down', require('./components/ScrollDown.vue').default);
Vue.component('ReCaptcha', require('./components/ReCaptcha.vue').default);
Vue.component('AvailableRoles', require('./components/AvailableRoles.vue').default);
Vue.component('Loader', require('./components/Loader.vue').default);
Vue.component('Eruda', require('./components/Eruda.vue').default);
Vue.component('cookie-banner', require('./components/CookieBanner.vue').default);

// projects
Vue.component('project-phase', require('./components/Projects/ProjectPhase.vue').default);
Vue.component('projects-showcase', require('./components/Projects/ProjectsShowcase.vue').default);
Vue.component('featured-projects', require('./components/Projects/FeaturedProjectsSlider.vue').default);

// news
Vue.component('news-showcase', require('./components/News/NewsShowcase.vue').default);
Vue.component('featured-news', require('./components/News/FeaturedNewsSlider.vue').default);


// separate page components
Vue.component('media-slider', require('./components/MediaSlider.vue').default);
Vue.component('image-modal', require('./components/ImageModal.vue').default);
Vue.component('career-form', require('./components/CareerForm.vue').default);
Vue.component('back-top', require('./components/BackToTop.vue').default);

// pages
Vue.component('Index', require('./components/Pages/Index.vue').default);
Vue.component('Contact', require('./components/Pages/Contact.vue').default);
Vue.component('Project', require('./components/Pages/Project.vue').default);
Vue.component('Projects', require('./components/Pages/Projects.vue').default);
Vue.component('news-article', require('./components/Pages/NewsArticle.vue').default);
Vue.component('all-news', require('./components/Pages/AllNews.vue').default);
Vue.component('Careers', require('./components/Pages/Careers.vue').default);
Vue.component('Career', require('./components/Pages/Career.vue').default);
Vue.component('privacy-policy', require('./components/Pages/PrivacyPolicy.vue').default);

Vue.component('app-header', require('./components/Layout/Header.vue').default);
Vue.component('app-footer', require('./components/Layout/Footer.vue').default);

Vue.mount('#app');
